import React, { createContext, useContext } from 'react';
import useFetchCart from './FetchCart';

const CartContext = createContext({
  cart: null,
  loading: true,
  error: null,
  fetchCart: () => {},
});

export const CartProvider = ({ children }) => {
  const cartData = useFetchCart(); // always returns an object
  return (
    <CartContext.Provider value={cartData}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
